export interface ContractInfo {
    name: string;
    uuid: string;
    documentUuid: string;
    versionUuid: string;
    versionNumber: number;
    dealType: string;
    fileFormats: FileFormat[];
    contractStatus: 'signed' | 'template' | 'negotiating';
    processingStatus:
        | 'processing'
        | 'processed'
        | 'failed'
        | 'awaiting_user_action';
    ownerId: string;
    reviewerIds: string[];
}

export enum FileFormat {
    DOCX = 'docx',
    PDF = 'pdf',
}

export enum DocumentFormat {
    ORIGINAL = 'original',
    HTML = 'indexed.html',
    DOCX = 'ast.docx',
    CONVERTED = 'convereted.html',
    JSON = 'paragraphs.json',
}
